import session from "../../api/session";

export const state = {
    loading: false,
    error: false,
    key: localStorage.getItem("key"),
    currentUserDetails: "",
    holidaysCurrentUser: "",
    hasHolidayModule: false,
    industry: false,
    entity: null,
    role_above: null
};

export const mutations = {
    LOGIN_BEGIN(state) {
        state.loading = true;
        state.error = false;
    },
    LOGIN_SUCCESS(state) {
        state.error = false;
        state.loading = false;
    },
    LOGIN_FAILURE(state) {
        state.error = true;
        state.loading = false;
    },
    SET_TOKEN(state, token) {
        localStorage.setItem("key", token);
        session.defaults.headers.Authorization = `Token ${token}`;
        state.key = token;
    },
    REMOVE_TOKEN(state) {
        localStorage.removeItem("key");
        delete session.defaults.headers.Authorization;
        state.key = null;
    },
    LOGOUT(state) {
        state.error = false;
        state.loading = false;
    },

    CURRENT_USER_BEGIN(state) {
        state.error = false;
        state.loading = true;
    },
    CURRENT_USER_SUCCESS(state, data) {
        state.error = false;
        state.loading = false;
        state.currentUserDetails = data;
    },

    CURRENT_USER_FAILURE(state) {
        state.error = true;
        state.loading = false;
    },
    HOLIDAYS_USER_BEGIN(state) {
        state.error = false;
        state.loading = true;
    },
    HOLIDAYS_USER_SUCCESS(state, data) {
        state.error = false;
        state.loading = false;
        state.holidaysCurrentUser = data;
    },
    HOLIDAYS_USER_FAILURE(state) {
        state.error = true;
        state.loading = false;
    },
    AUTHREQUIRED(state) {
        state.error = false;
        state.loading = false;
    },
    ENTITY(state, data) {
        state.entity = data;
    },
    INDUSTRY(state, data) {
        state.industry = data;
        state.hasHolidayModule = data;
    },
    ROLE_ABOVE(state, data) {
        state.role_above = data;
    },
};

export const getters = {
    // Whether the user is currently logged in.
    loggedIn(state) {
        return !!state.key;
    },
    objectUser(state) {
        return state.currentUserDetails && state.currentUserDetails.user ?
            state.currentUserDetails.user :
            "";
    },
    userDetails(state) {
        return state.currentUserDetails;
    },
    userRole(state) {
        return state.currentUserDetails.role;
    },
    is_staff(state) {
        return state.currentUserDetails.user ?
            state.currentUserDetails.user.is_staff :
            "";
    },
    is_superuser(state) {
        return state.currentUserDetails.user ?
            state.currentUserDetails.user.is_superuser :
            "";
    },
    is_supervisor(state) {
        // // !! for truthy value. It returned undefined if it wasn't supervisor because of query exists
        // return !!state.currentUserDetails.entity;
        return state.currentUserDetails ?
            state.currentUserDetails.is_supervisor :
            "";
    },
    has_entity_groups(state) {
        return state.entity;
    },
    has_holiday_module(state) {
        return state.hasHolidayModule;
    },
    has_role_above(state) {
        return state.role_above;
    }

};

export const actions = {
    async logIn({ commit }, { username, password }) {
        commit("LOGIN_BEGIN");
        return await session
            .post("api/login/", { username, password })
            .then(({ data }) => commit("SET_TOKEN", data.key))
            .then(() => commit("LOGIN_SUCCESS"));
        // .catch(() => commit('LOGIN_FAILURE'))
    },

    // Logs out the current user.
    async logOut({ commit }) {
        return await session
            .post("api/logout/", {})
            .then(() => commit("LOGOUT"))
            .finally(() => commit("REMOVE_TOKEN"));
    },

    async validate({ commit }) {
        const key = localStorage.getItem(key);

        if (key) {
            console.log("validate", key);
            return key;
        } else {
            commit("LOGIN_SUCCESS");
            return Promise.resolve(null);
        }
    },

    async currentUser({ commit }) {
        commit("CURRENT_USER_BEGIN");
        return await session
            .get("api/user/me/")
            .then(({ data }) => commit("CURRENT_USER_SUCCESS", data))
            .catch(() => commit("CURRENT_USER_FAILURE"));
    },
    async validUserToken({ commit }) {
        const key = localStorage.getItem("key");
        if (key) {
            // delete session.defaults.headers.Authorization;
            try {
                const response = await session.get(`api/token-validation/${key}/`);
                if (response.data.token) {
                    commit("AUTHREQUIRED");
                    return key;
                } else {
                    Promise.resolve(null);
                }
            } catch (error) {
                delete session.defaults.headers.Authorization;
                return Promise.resolve(null);
            }
        }
        return Promise.resolve(null);
    },
    async getEntity({ commit }) {

        return await session
            .get("api/has-entity-groups/")
            .then(({ data }) => {
                commit("ENTITY", data)
            })
    },
    async getIndustry({ commit }) {

        return await session
            .get("api/has-holiday-module/")
            .then(({ data }) => {
                commit("INDUSTRY", data)
            })
    },
    async getRole({ commit }) {
        return await session
            .get("api/role-above/")
            .then(({ data }) => {
                commit("ROLE_ABOVE", data)
            })
    },
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
};